import { Autocomplete, MenuItem, TextField } from '@mui/material'
import { Rubro } from '../types/rubro'

interface DesplegableRubrosPadresProps {
  rubros: Rubro[]
  onChange: (param?: any, value?: any) => void
  prevValue?: any
}

const ninguno: Rubro = {
  activo: true,
  listable: true,
  idEspacioTemplate: 0,
  codRubro: '',
  nombre: 'Ninguno',
  orden: 0,
  codRubroPadre: null,
  nombreAnalytics: 'Ninguno',
  nombreCompleto: '',
  rubros: [],
  precioMinimo: 0,
  unidadDeMedidaList: [],
  atributosPermitidos: [],
  monedaList: [],
  slug: null,
  urlFoto: null,
  urlIcono: null,
  urlPortada: null,
  buscadorImagenNombreCaption: null,
  keywords: null,
  color: null
}

const DesplegableRubrosPadres = ({ onChange, rubros, prevValue }: DesplegableRubrosPadresProps) => {
  return (
    <Autocomplete
      options={rubros}
      getOptionLabel={(rubro: Rubro) => rubro.nombreAnalytics || ''}
      value={prevValue === 0 ? ninguno : prevValue}
      onChange={onChange}
      isOptionEqualToValue={(option, value) => option.codRubro === value.codRubro} // 👈 esto
      renderInput={(params) => (
        <TextField
          {...params}
          onKeyPress={(e) => e.key === 'Enter'}
          variant="outlined"
          placeholder="Seleccione"
          InputLabelProps={{ disableAnimation: true }}
        />
      )}
      renderOption={(props, rubro) => (
        <MenuItem {...props} key={rubro.codRubro} value={rubro.codRubro}>
          {rubro.nombreAnalytics}
        </MenuItem>
      )}
    />
  )
}

export default DesplegableRubrosPadres
